import { Spinner } from '@schibsted-svp/react-ui';
import classnames from 'classnames/bind';
import { IMAGE_TYPES } from 'components/AssetForm/types';
import { THEME_IMAGE_TYPES } from 'screens/NewsroomScreen/PlaylistsScreen/types';
import * as PropTypes from 'prop-types';
import { MdCrop, MdDeleteForever } from 'react-icons/md';
import PosterPlaceholder from './PosterPlaceholder';
import css from './PosterPreview.module.scss';

const cln = classnames.bind(css);

function PosterPreview({
    src = null,
    width = 300,
    loading = false,
    highlighted = false,
    enableCrop = false,
    minimumSize,
    maximumSize,
    toggleCropImageDialog,
    clearUploadedImage,
    handlePosterChange,
    onVideoPosterUpload,
    type,
}) {
    // Don't add query params if it's a base64 data or blob
    const url = /^(data:image|blob:)/.test(src) ? src : `${src}?t[]=${width}q80`;

    return (
        <div className={css.wrapper}>
            {!src ? (
                <PosterPlaceholder
                    handlePosterChange={handlePosterChange}
                    onVideoPosterUpload={onVideoPosterUpload}
                    type={type}
                    minimumSize={minimumSize}
                    maximumSize={maximumSize}
                />
            ) : (
                <>
                    <img
                        src={url}
                        alt="Poster preview"
                        className={cln(css.image, { 'image--highlighted': highlighted })}
                    />
                    {loading ? (
                        <Spinner speed={120} containerClassName={css.spinner} />
                    ) : (
                        <ul className={css.toolbox}>
                            {enableCrop && (
                                <li>
                                    <MdCrop onClick={toggleCropImageDialog} />
                                </li>
                            )}
                            {clearUploadedImage && (
                                <li>
                                    <MdDeleteForever onClick={clearUploadedImage} />
                                </li>
                            )}
                        </ul>
                    )}
                </>
            )}
        </div>
    );
}

PosterPreview.propTypes = {
    src: PropTypes.string,
    width: PropTypes.number,
    loading: PropTypes.bool,
    enableCrop: PropTypes.bool,
    minimumSize: PropTypes.arrayOf(PropTypes.number),
    maximumSize: PropTypes.arrayOf(PropTypes.number),
    toggleCropImageDialog: PropTypes.func.isRequired,
    clearUploadedImage: PropTypes.func,
    highlighted: PropTypes.bool,
    handlePosterChange: PropTypes.func.isRequired,
    onVideoPosterUpload: PropTypes.func.isRequired,
    type: PropTypes.oneOf([...IMAGE_TYPES, ...THEME_IMAGE_TYPES]).isRequired,
};

export default PosterPreview;
